import {
  Anchor,
  Grip,
  Grid3x3,
  Crown,
  Sparkles,
  Smile,
  GitCommitHorizontal,
  Layers,
  Activity,
  Sun,
} from "lucide-react";

// Map string keys (from data) to lucide icon components.
export const ICONS = {
  Anchor,
  Grip,
  Grid3x3,
  Crown,
  Sparkles,
  Smile,
  GitCommitHorizontal,
  Layers,
  Activity,
  Sun,
};

export function TreatmentIcon({ name, className = "h-6 w-6" }) {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp className={className} aria-hidden="true" />;
}
